export default {"src":"/_next/static/media/LOW.f0a658fc.svg","height":18,"width":18};